import type React from "react";

export function InfoCircleIcon(props: {
  size?: "small" | "large";
}): React.ReactNode {
  if (props.size === "large") return largeIcon;

  return smallIcon;
}

const smallIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    display="block"
    fill="currentColor"
  >
    <title>Info Circle</title>
    <g id="noun_Info_1228105" transform="translate(-5 -5)">
      <path
        id="Path_2395"
        data-name="Path 2395"
        d="M13,21a8,8,0,1,0-8-8A8,8,0,0,0,13,21Zm.444-13.2a1.333,1.333,0,1,1-1.333,1.333A1.333,1.333,0,0,1,13.444,7.8ZM13,11.089c1.333,0,1.657.787,1.507,1.757l-.618,4.021a3.44,3.44,0,0,0,1.333-.444A2.372,2.372,0,0,1,13,18.2c-1.333,0-1.657-.787-1.507-1.757l.618-4.021a3.44,3.44,0,0,0-1.333.444A2.372,2.372,0,0,1,13,11.089Z"
      />
    </g>
  </svg>
);

const largeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="90"
    height="90"
    viewBox="0 0 90 90"
    display="block"
    fill="currentColor"
  >
    <title>Info Circle</title>
    <g id="noun_Info_1228105" transform="translate(-5 -5)">
      <path
        id="Path_2395"
        data-name="Path 2395"
        d="M50,95A45,45,0,1,0,5,50,45,45,0,0,0,50,95Zm2.5-74.25a7.5,7.5,0,1,1-7.5,7.5A7.5,7.5,0,0,1,52.5,20.75ZM50,39.25c7.5,0,9.319,4.425,8.479,9.884L55,71.75s2.5,0,7.5-2.5c0,0-2.5,10-12.5,10-7.5,0-9.319-4.425-8.479-9.884L45,46.75s-2.5,0-7.5,2.5C37.5,49.25,40,39.25,50,39.25Z"
      />
    </g>
  </svg>
);
